<template>
    <div class="image-cropper-container">
        <pop-up-images ref="popUpImages" @selectedGalleryImage="imageSelectedGallery" @uploadCustomThumbnail="uploadThumbnail" @uploadHero="uploadHero" @upload2x3="upload2x3"></pop-up-images>
        <div v-if="isAlertVisible" class="help-alert">
            <p>When using the hero image on Roku, please be aware that there will be an overlay box covering a portion. Ensure important logos or text in the hero image are not obstructed. Here's an approximate example for reference:</p>
            <div class="image-container">
                <div class="image-overlay-help">
                    <p>Video name</p>
                </div>
                <img :src="baseUrl+imageTooltip" alt="">
            </div>
        </div>
        <transition-group name="image-slider">
            <div class="compressed-images" :key="1">
                <div class="img-copped-container">
                    <div class="image-section">
                        <div class="aspect-ratio-selection">
                            <input type="radio" v-model="aspectRatio" value="16/9" class="input-radio" /> Thumbnail (16x9)
                        </div>
                        <div class="cropped-images" @click="popUpImagesOpen('custom')" id="add-thumbnail-image">
                            <div class="cropped-image" :class="{ 'selected': aspectRatio === '16/9' }" @click="changeAspectRatio('16/9')">
                                    <img v-if="shouldDisplayVideoImage()" :src="getElementImage()" />
                                    <img v-else-if="shouldDisplaySerieImage()" :src="getElementImage()" />
                                    <img v-else-if="shouldDisplayDistributionImage()" :src="getElementImage()" />
                                    <i v-else class="fa fa-plus icon-card"></i>
                            </div>
                        </div>
                    </div>
                    <div class="image-section">
                        <div class="aspect-ratio-selection hero-card">
                            <input type="radio" v-model="aspectRatio" value="9/4" class="input-radio" /> Hero (9x4)
                            <div class="help-icon" @mouseover="showInstructions" @mouseout="hideInstructions">
                                <i class="fa fa-info-circle"></i>
                            </div>
                        </div>
                        <div class="cropped-images" @click="popUpImagesOpen('heroimage')" id="add-hero-image">
                            <div class="cropped-image" :class="{ 'selected': aspectRatio === '9/4' }"
                                @click="changeAspectRatio('9/4')">
                                <div class="image-container" v-if="(mediaItem.heroImage !== 'false' && mediaItem.heroImage) || heroImage || heroImageGallery">
                                    <div class="image-overlay" ></div>
                                        <img v-if="(mediaItem.heroImage !== 'false' && mediaItem.heroImage) || heroImage"
                                            :src="heroImage ? heroImage : heroImageGallery ? baseUrl+heroImageGallery :baseUrl+mediaItem.heroImage" alt="Cropped Image 9x4" />
                                    </div>
                                    <i v-else class="fa fa-plus icon-card"></i>
                            </div>
                        </div>
                    </div>
                    <div v-if="!isDistribution" class="image-section">
                        <div class="aspect-ratio-selection">
                            <input type="radio" v-model="aspectRatio" value="2/3" class="input-radio" /> Poster (2x3)
                        </div>
                        <div class="cropped-images" @click="popUpImagesOpen('thumbnail2x3')" id="add-2x3-image">
                            <div class="cropped-image container-2x3" :class="{ 'selected': aspectRatio === '2/3' }"
                                @click="changeAspectRatio('2/3')">
                                <img v-if="mediaItem.thumbnail2x3 || thumbnail2x3 || thumbnail2x3Gallery"
                                    :src="thumbnail2x3 ? thumbnail2x3 : thumbnail2x3Gallery ? baseUrl+thumbnail2x3Gallery : baseUrl+mediaItem.thumbnail2x3"
                                    alt="Cropped Image 2x3" />
                                <i v-else class="fa fa-plus icon-card"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
import PopUpImages from "./PopUpImages.vue";

export default {
    components: {
        PopUpImages
    },
    props: {
        accountID: {
            type: String,
        },
        mediaItem: {
            type: Object,
        },
        isDistribution: {
            type: Boolean,
            default: false,
        },
        isSeries: {
            type: Boolean,
            default: false,
        },
        isMediaItem: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            destination: null,
            aspectRatio: "16/9",
            customThumbnail: null, // image 16x9
            heroImage: null, // image 9x4
            thumbnail2x3: null, // image 2x3
            customThumbnailGallery: null, // image 16x9
            heroImageGallery: null, // image 9x4
            thumbnail2x3Gallery: null, // image 2x3
            baseUrl: `https://s3.us-east-1.amazonaws.com/${process.env.IMAGES_BUCKET_NAME}/`,
            imageTooltip: 'hero-tooltip.jpeg',
            isAlertVisible: false,
            aspectImageSelected: '',
        };
    },
    methods: {
        imageSelectedGallery(image){
            const aspect = this.aspectImageSelected;
            if(aspect === 'custom'){
                this.customThumbnail = null
                this.customThumbnailGallery = image
                this.$emit('uploadSuccessPoster', { url: `${image}` });
            }
            if(aspect === 'heroimage') {
                this.heroImage = null
                this.heroImageGallery = image
                this.$emit('uploadSuccessHero', { url: `${image}` });
            }

            if(aspect === 'thumbnail2x3') {
                this.thumbnail2x3 = null
                this.thumbnail2x3Gallery = image
                this.$emit('uploadSuccessPortrait', { url: `${image}` });
            };
        },
        uploadThumbnail({url}){
            this.customThumbnailGallery = null
            this.$emit('uploadSuccessPoster', { url: url });
        },
        uploadHero({url}){
            this.heroImageGallery = null
            this.$emit('uploadSuccessHero', { url: url });
        },
        upload2x3({url}){
            this.thumbnail2x3Gallery = null
            this.$emit('uploadSuccessPortrait', { url: url });
        },
        popUpImagesOpen(aspectImageSelected){
            this.aspectImageSelected = aspectImageSelected;
            this.$refs.popUpImages.openDialog(aspectImageSelected)
        },
        showInstructions() {
            this.isAlertVisible = true;
        },
        hideInstructions() {
            this.isAlertVisible = false;
        },
        changeAspectRatio(newAspectRatio) {
            this.aspectRatio = newAspectRatio;
        },
        shouldDisplayVideoImage() {
            return this.isMediaItem && (this.mediaItem.customThumbnail || (this.mediaItem.poster.default && !this.mediaItem.poster.default.endsWith('media-item-poster-placeholder.svg'))) ;
        },
        shouldDisplaySerieImage() {
            return this.isSeries && (this.customThumbnail || this.customThumbnailGallery || this.mediaItem.thumbnail);
        },
        shouldDisplayDistributionImage() {
            return this.isDistribution && this.mediaItem.poster && this.mediaItem.poster !== 'false';
        },
        getElementImage() {
            let url =""

            if (this.shouldDisplayVideoImage()) {
                url = this.mediaItem.customThumbnail || this.mediaItem.poster.default;

            } else if (this.shouldDisplaySerieImage()) {
                url = this.customThumbnail ? this.customThumbnail : this.customThumbnailGallery ? this.customThumbnailGallery : this.mediaItem.thumbnail;
                return `${this.baseUrl}${url}`;
            } else if (this.shouldDisplayDistributionImage()) {
                url = this.mediaItem.poster
            }

            if (url.startsWith("http"))
                return url;
            return `${this.baseUrl}${url}`;
        }

    },
    watch: {
        aspectRatio(newValue) {
            if (this.cropper) {
                this.cropper.setAspectRatio(eval(newValue));
            }
        },
    },
};
</script>

<style scoped>
.input-radio{
    display: none;
}
.icon-card{
    margin-top: 40px;
    margin-left: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    height: 50%;
    border: 1px solid #aaa8a8;
    font-size: 50px;
    color: #aaa8a8;
}
.container-images {
    width: 100%;
    display: flex;
    flex-wrap: wrap ;
    justify-content: center;
    max-height: 400px;
    overflow-y: auto;
}

.img-folder{
    width: 200px;
    height: 100px;
    margin: 5px;
    object-fit: contain;
}
.custom-file-upload {
    display: inline-block;
    padding: 10px 20px;
    cursor: pointer;
    background-color: transparent;
    border: 1px solid #4785a9;
    border-radius: 5px;
    margin-bottom: 20px;
    transition: all 0.1s ease-in-out;
}

.custom-file-upload:hover {
    color: #fff;
    background-color: #4785a9;
}

.image-cropper-container {
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.image-section {
    border-radius: 6px;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    height: 250px;
    object-fit: cover;
    margin-right: 10px;
    margin-top: 10px;
}

.img-container img {
    max-width: 100%;
    height: auto;
}

.img-copped-container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
}

.original-image {
    margin-right: 10px;
}

.original-image img {
    max-width: 450px;
    max-height: 450px;
}

.aspect-ratio-selection {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
    font-size: large;
}

.hero-card {
    position: relative;
}
.img-cropped {
    max-width: 100%;
    height: auto;
}

.cropped-images {
    width: 100%;
    height: 100%;
}

.cropped-image {
    border: 2px;
    margin-right: 10px;
    width: 200px;
    height: 200px;
    margin-left: 10px;
    :hover {
        cursor: pointer;
    }
}

.cropped-image img {
    height: 200px;
    width: 100%;
    object-fit: contain;
}
.container-2x3 img{
    margin-top: 20px;
    height: 80%;
}
.image-container {
    position: relative;
    display: inline-block;
}

.image-overlay {
    border: 1px solid white;
    position: absolute;
    top: 75px;
    left: 10px;
    width: 80px;
    height: 40px;
    background-color: rgba(115, 113, 113, 0.7);
}

.image-slider-enter-active,
.image-slider-leave-active {
    transition: max-height 0.1s ease-out;
}

.image-slider-enter,
.image-slider-leave-to{
    max-height: 0;
    overflow: hidden;
}

.image-slider-move {
    transition: transform 0.1s;
}

.compressed-images {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.container-buttons {
    display: flex;
    justify-content: center;
}
.help-icon {
    position: absolute;
    right: 10px;
    cursor: pointer;
}


.help-icon i {
    color: #f6af16;
    font-size: 24px;
}
.help-alert p{
    margin: 5px;
    margin-right: 5px;
    font-size: 14px;
}

.help-alert {
    position: absolute;
    display: flex;
    align-items: center;
    bottom: 100px;
    padding: 4px 8px;
    background-color: rgb(244, 244, 244);
    border-radius: 5px;
    max-width: 550px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    z-index: 9999;
}

.image-overlay-help {
    position: absolute;
    top: 20px;
    left: 10px;
    width: 90px;
    height: 45px;
    background-color: rgba(125, 125, 125, 0.8);
}

.image-overlay-help p {
    color: white;
    margin-left: 5px;
    margin-top: 5px;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/upload/ImageUploadCroped.vue